/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchDepScheduleDTO } from '../models/BranchDepScheduleDTO';
import type { BranchDTO } from '../models/BranchDTO';
import type { BrancheDistanceDTO } from '../models/BrancheDistanceDTO';
import type { BranchReferenceDTO } from '../models/BranchReferenceDTO';
import type { BranchScheduleDepartmentInput } from '../models/BranchScheduleDepartmentInput';
import type { BranchSchedulesDTO } from '../models/BranchSchedulesDTO';
import type { BranchType } from '../models/BranchType';
import type { GlobalInfoDto } from '../models/GlobalInfoDto';
import type { GlobalInfoInput } from '../models/GlobalInfoInput';
import type { GlobalInfoServiceInput } from '../models/GlobalInfoServiceInput';
import type { GlobalInfoSpecialOfferInput } from '../models/GlobalInfoSpecialOfferInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BranchService {

  /**
   * Get all active branches
   * @returns BranchDTO Success
   * @throws ApiError
   */
  public static getBranch(): CancelablePromise<Array<BranchDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Branch',
    });
  }

  /**
   * Calculate distance for branches by postcode
   * @param postcode Postcode
   * @param branches List of branch types
   * @returns BrancheDistanceDTO Success
   * @throws ApiError
   */
  public static getBranchDistance(
postcode?: string,
branches?: Array<BranchType>,
): CancelablePromise<Array<BrancheDistanceDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Branch/Distance',
      query: {
        'postcode': postcode,
        'branches': branches,
      },
    });
  }

  /**
   * Get branch departments schedule
   * @param branchId 
   * @returns BranchDepScheduleDTO Success
   * @throws ApiError
   */
  public static getBranchSchedule(
branchId?: number,
): CancelablePromise<Array<BranchDepScheduleDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Branch/Schedule',
      query: {
        'branchId': branchId,
      },
    });
  }

  /**
   * Get all branches departments schedules
   * @returns BranchSchedulesDTO Success
   * @throws ApiError
   */
  public static getBranchSchedules(): CancelablePromise<Array<BranchSchedulesDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Branch/Schedules',
    });
  }

  /**
   * @returns GlobalInfoDto Success
   * @throws ApiError
   */
  public static getBranchGlobalInfo(): CancelablePromise<GlobalInfoDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Branch/global-info',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putBranchGlobalInfo(
requestBody?: GlobalInfoInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Branch/global-info',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postBranchGlobalInfoServices(
requestBody?: GlobalInfoServiceInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Branch/global-info/services',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteBranchGlobalInfoServices(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Branch/global-info/services/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postBranchGlobalInfoSpecialOffers(
requestBody?: GlobalInfoSpecialOfferInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Branch/global-info/special-offers',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static putBranchGlobalInfoSpecialOffers(
id: number,
requestBody?: GlobalInfoSpecialOfferInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Branch/global-info/special-offers/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteBranchGlobalInfoSpecialOffers(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Branch/global-info/special-offers/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns BranchReferenceDTO Success
   * @throws ApiError
   */
  public static getBranchReferences(): CancelablePromise<Array<BranchReferenceDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Branch/references',
    });
  }

  /**
   * @param formData 
   * @returns number Created
   * @throws ApiError
   */
  public static postBranchReferences(
formData?: {
Active: boolean;
Name: string;
ShortName: string;
Code: string;
ExternalCode: string;
Number: number;
MobilePhone?: string;
SalePhone: string;
'Address.FullAddress': string;
'Address.PostCode': string;
'Address.StreetAddress': string;
'Address.Locality': string;
'Address.Region': string;
GoogleUrl?: string;
Latitude: number;
Longitude: number;
FacebookLink?: string;
TwitterLink?: string;
InstagramLink?: string;
YouTubeLink?: string;
TikTokLink?: string;
Image?: Blob;
UpdateImage?: boolean;
DepartmentSchedules: Array<BranchScheduleDepartmentInput>;
},
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Branch/references',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @returns BranchReferenceDTO Success
   * @throws ApiError
   */
  public static getBranchReferences1(
id: number,
): CancelablePromise<BranchReferenceDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Branch/references/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static putBranchReferences(
id: number,
formData?: {
Active: boolean;
Name: string;
ShortName: string;
Code: string;
ExternalCode: string;
Number: number;
MobilePhone?: string;
SalePhone: string;
'Address.FullAddress': string;
'Address.PostCode': string;
'Address.StreetAddress': string;
'Address.Locality': string;
'Address.Region': string;
GoogleUrl?: string;
Latitude: number;
Longitude: number;
FacebookLink?: string;
TwitterLink?: string;
InstagramLink?: string;
YouTubeLink?: string;
TikTokLink?: string;
Image?: Blob;
UpdateImage?: boolean;
DepartmentSchedules: Array<BranchScheduleDepartmentInput>;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Branch/references/{id}',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

}
